import { omitKeys } from '@adsk/alloy-react-helpers';

/**
 * Strips unused, and untyped properties from an object.
 *
 * Because dropdown hooks provide spreadable objects for control and menu props,
 * we can get console warnings for unrecognized props passed to DOM elements.
 *
 * Internalizing this stripping in Dropdown lets our consumers continue spreading without trouble.
 * @param object Props object provided to the component
 * @param unknownProperties Props that are returned from the dropdown hook, but unused by this component
 * @returns Props object, guaranteed to not have and key provided in @see unknownProperties
 */
export const stripUnknownProps = <T extends object, K extends string>(
  object: T,
  unknownProperties: K[],
) => {
  type UnusedKey = (typeof unknownProperties)[number];

  return omitKeys(
    object as typeof object & Record<UnusedKey, unknown>,
    unknownProperties,
  );
};
